import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, TypographyConfig, Micro, Body } from '@vds-core/typography';
var propTypes = {
  /**
   * @ignore config for passing though typography
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  margin: PropTypes.string,

  /**
   * @ignore
   */
  typescale: PropTypes.string
};
var defaultProps = {
  bodyConfig: BodyConfig,
  margin: calculateRem(4),
  typescale: TypographyConfig.getTypescale()
};
var InputTextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "InputTextWrapper",
  componentId: "sc-1wiyhm4-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  margin-top: ", ";\n  color: ", ";\n"])), function (_ref) {
  var margin = _ref.margin,
      typescale = _ref.typescale;
  return typescale === 'VDS' ? calculateRem(8) : margin;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.black;
});

var _configureTypography = function _configureTypography(bodyConfig, typescale, children) {
  if (typescale === 'VDS') {
    return /*#__PURE__*/React.createElement(Body, {
      config: bodyConfig,
      typescale: typescale,
      className: "formText"
    }, children);
  } else {
    return /*#__PURE__*/React.createElement(Micro, {
      className: "formText"
    }, children);
  }
};
/**
 * @ignore
 */


var InputText = function InputText(_ref3) {
  var margin = _ref3.margin,
      bodyConfig = _ref3.bodyConfig,
      typescale = _ref3.typescale,
      children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    role: "alert"
  }, /*#__PURE__*/React.createElement(InputTextWrapper, {
    typescale: typescale,
    margin: margin
  }, _configureTypography(bodyConfig, typescale, children)));
};

InputText.propTypes = propTypes;
InputText.defaultProps = defaultProps;
export default InputText;